module.exports = __webpack_public_path__ + "img/muban.1fa8d550.png";